import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import Footer from '../components/Footer';
import { XCircle, ArrowLeft, Wallet } from 'lucide-react';
import { motion } from 'framer-motion';

export default function PaymentCancelPage() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex flex-col bg-rolex-green">
      <main className="flex-1 flex items-center justify-center px-4 py-12">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="w-full max-w-xl">
          <Card className="bg-cream border-2 border-gold/30 shadow-2xl">
            <CardContent className="p-10 text-center">
              <div className="w-20 h-20 rounded-full bg-stone-200 flex items-center justify-center mx-auto mb-6">
                <XCircle className="w-10 h-10 text-stone-600" />
              </div>
              <h1 className="font-display text-2xl font-bold text-rolex-green mb-3">Paiement annulé</h1>
              <p className="text-rolex-green/65 mb-8">
                Aucun montant n'a été débité. Vous pouvez réessayer à tout moment.
              </p>
              <div className="flex flex-col sm:flex-row gap-3 justify-center">
                <Button onClick={() => navigate(-1)} className="btn-gold gap-2">
                  <ArrowLeft className="w-4 h-4" /> Retour
                </Button>
                <Button variant="outline" onClick={() => navigate('/wallet')} className="border-gold/40 text-rolex-green hover:bg-gold/10 gap-2">
                  <Wallet className="w-4 h-4" /> Voir les packs
                </Button>
              </div>
            </CardContent>
          </Card>
        </motion.div>
      </main>
      <Footer />
    </div>
  );
}
